export const successMessages = {
  newUser: "New user has been created.",
};
